'use client';

import { c as _c } from "react/compiler-runtime";
import Small from '@images/renders/infrastructure_images/Infra_Desktop_Webp/5.webp';
import Big from '@images/renders/infrastructure_images/Infra_Desktop_Webp/6.webp';
import Big_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/5.webp';
import Small_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/6.webp';
import cn from 'classnames';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import style from './FourthScreenInfra.module.scss';
function FourthScreenInfraMobile() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={style.fourthScreenTitle}><p>Парк активностей </p><p>и развлечений</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenDescription}><p>После школы тоже не придётся скучать. Линейный парк с вереницей спортивных  и игровых площадок, полосой препятствий, скалодромом  направит энергию в активное и полезное русло.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ParallaxMedia src={Big} src375={Big_Mob} className={cn(style.fourthScreenImgBigMob, style.zIndexMinusOne)} alt="BigImg" imagePlug={Big} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div data-scroll={true} className={style.fourthScreenContainer} id="four"><div data-scroll={true} className={style.fourthScreenContainer}><div className={style.fourthScreenTextBox}>{t0}{t1}{t2}<span className={style.fourthScreenImgWrapper}><ParallaxMedia speed={0.1} offset={-100} end={5000} src={Small} src375={Small_Mob} alt="SmallImg" className={style.fourthScreenImgSmallMob} imagePlug={Small} /></span></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default FourthScreenInfraMobile;